import { render } from "./CGHeader.vue?vue&type=template&id=6f4c4085"
import script from "./CGHeader.vue?vue&type=script&lang=js"
export * from "./CGHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__